/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-restricted-syntax
export enum RecAiPage {
  ProductDetails = 0,
  Home = 1,
  Cart = 2,
  MyAccount = 3,
}

// eslint-disable-next-line no-restricted-syntax
export enum RecAiType {
  RecommendedProductsForYou,
  FrequentlyBoughtTogether,
}
